/* The welcome with nothing booked (prototype .b4Next, .b4Name, .b4Line, .bQuiet), in the telify layer. */
@layer telify {
  .empty {
    margin-top: 16px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 48px;
  }

  .title {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 56px;
    line-height: 1.02;
    letter-spacing: -0.02em;
  }

  .name {
    color: var(--accent);
  }

  .line {
    margin-top: 16px;
    font-size: 20px;
    line-height: 1.5;
  }

  .last {
    margin-top: 10px;
    font-size: 18px;
  }

  .ctas {
    display: flex;
    gap: 12px;
    flex-shrink: 0;
  }

  .book {
    height: 52px;
    padding: 0 26px;
    flex-shrink: 0;
  }

  @media (max-width: 1023px) {
    .empty {
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
    }

    .title {
      font-size: 40px;
    }
  }
}
